<template>
    <rkm-modal
        ref="RkmModal"
        title="Sigilo"
        extra-large
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :repository="repositories.ocupacao"
                        :search-fields="searchFields"
                        :text-field="(item) => item.codigo ? `${item.codigo} - ${item.nome}` : null"
                        :validations="validations.ocupacao"
                        label="CBO"
                        v-model="model.ocupacao"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :options="data.form.unidades"
                        :validations="validations.unidade"
                        @change="handleUnidadeChange"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.infraestruturas"
                        :validations="validations.infraestrutura"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :options="data.form.sigiloTipos"
                        :validations="validations.sigiloTipo"
                        label="Tipo de sigilo"
                        show-default-option
                        text-field="nome"
                        v-model="model.sigiloTipoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="include"
                color="primary"
            >
                Incluir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        searchFields() {
            return [
                {key: 'ocupacao.codigo', searchable: true},
                {key: 'ocupacao.nome', searchable: true},
            ]
        },
        validations() {
            return {
                ocupacao: {required: true},
                infraestrutura: {required: !!this.model.unidadeId},
                sigiloTipo: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            ocupacao: this.getConectaSusRepository('sigtap.ocupacao'),
            parametrizacao: this.getConectaSusRepository('ambulatorio.parametrizacao'),
        }
    },
    data: () => ({
        model: {
            ocupacao: null,
            unidadeId: null,
            infraestruturaId: null,
            sigiloTipoId: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {
            this.resetForm()
            this.$refs.RkmModal.show()
        },
        handleUnidadeChange(value) {
            this.data.form.infraestruturas = []
            this.model.infraestruturaId = null

            if (value === null) return

            const request = {
                origem: 'sigilo',
                listar: 'infraestruturas',
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.parametrizacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.data.form.infraestruturas = response.data

                    if (response.data.length === 1) {
                        this.model.infraestruturaId = response.data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        include() {
            if (this.data.model.sigilos.find(sigilo => sigilo.ocupacao.id === this.model.ocupacao.id && sigilo.infraestruturaId === this.model.infraestruturaId && sigilo.deleted === false)) {
                this.showValidationNotification('O sigilo já foi incluído.')
                return
            }

            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const ocupacao = this.model.ocupacao
                    const unidade = this.data.form.unidades.find(unidade => unidade.id === this.model.unidadeId)
                    const infraestrutura = this.data.form.infraestruturas.find(infraestrutura => infraestrutura.id === this.model.infraestruturaId)
                    const sigiloTipo = this.data.form.sigiloTipos.find(sigiloTipo => sigiloTipo.id === this.model.sigiloTipoId)

                    this.data.model.sigilos.push({
                        ocupacao: {
                            id: ocupacao.id,
                            codigo: ocupacao.codigo,
                            nome: ocupacao.nome,
                        },
                        unidadeNomeFantasia: unidade ? unidade.nomeFantasia : null,
                        infraestruturaId: infraestrutura ? infraestrutura.id : null,
                        infraestruturaNome: infraestrutura ? infraestrutura.nome : null,
                        sigiloTipoId: sigiloTipo.id,
                        sigiloTipoNome: sigiloTipo.nome,
                        infraestruturas: [],
                        ocupacoes: [],
                        deleted: false,
                    })

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.data.form.infraestruturas = []
            this.model.ocupacao = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.sigiloTipoId = null

            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {required: true, type: Object},
    },
}
</script>